module.exports = __webpack_public_path__ + "static/media/AstroBearLogo.05b993df.png";